
import {React} from "react";
import { Spinner, Container, Text } from "retro-react-update";

    export const LoadingBox = () =>{
        return(
        <Container
            sx={{
                alignItems: 'center',
                background: '#c0c0c0',
                display: 'flex',
                flexDirection: 'column',
                gap: 3,
                height: '150px',
                justifyContent: 'center',
                padding: 3,
                width: '300px'
            }}
            >
            <Text
                sx={{
                fontFamily: 'MS Sans Serif, sans-serif',
                fontSize: '11px',
                fontWeight: 'bold'
                }}
            >
                Processing...
            </Text>
            <Spinner
                size="medium"
                variant="dots"
            />
            <Text
                sx={{
                fontFamily: 'MS Sans Serif, sans-serif',
                fontSize: '11px'
                }}
            >
                Please wait...
            </Text>
        </Container>
    )
}
